import { Injectable } from '@angular/core';
import { deviceMessageId } from '../enums/device-message-id.enum';
import { deviceMessageProperties } from '../enums/device-message-properties';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class NativeBridgeSanitizerService {
  constructor(private notificationService: NotificationService) {}

  sanitizeMessage(message: string): any {
    const messageToObject = JSON.parse(message);
    const hasCorrectType = typeof messageToObject == 'object';
    if (hasCorrectType) {
      return this._correctMessageStructure(messageToObject);
    } else {
      return new Error('El mensaje no es objeto');
    }
  }

  private _correctMessageStructure(message: Object): Object {
    const hasMessageProperty = this._messageHasProperty(message, deviceMessageProperties.MESSAGE_ID);
    if (hasMessageProperty && this._hasValidMessageId(message)) {
      const message_id = message['message_id'];
      const scanQrResponseInvalid =
        message_id == deviceMessageId.SCAN_QR_RESPONSE &&
        (!this._messageHasProperty(message, deviceMessageProperties.RESPONSE_ID) ||
          (this._messageHasProperty(message, deviceMessageProperties.RESPONSE_ID) &&
            !this._messageHasProperty(message, deviceMessageProperties.BARCODE_DATA) &&
            !this._messageHasProperty(message, deviceMessageProperties.USER_CANCEL)));
      const scanQrInvalid =
        message_id == deviceMessageId.ACTION_SCAN_QR &&
        !this._messageHasProperty(message, deviceMessageProperties.REQUEST_ID);
      const setEnvironmentInvalid =
        message_id == deviceMessageId.SET_ENVIRONMENT &&
        !this._messageHasProperty(message, deviceMessageProperties.ENVIRONMENT);
      const getWebVersionInvalid =
        message_id == deviceMessageId.GET_WEB_VERSION &&
        !this._messageHasProperty(message, deviceMessageProperties.REQUEST_ID);
      const setWebVersionInvalid =
        message_id == deviceMessageId.SET_WEB_VERSION &&
        !this._messageHasProperty(message, deviceMessageProperties.RESPONSE_ID);
      const userSignOutInvalid =
        message_id == deviceMessageId.USER_SIGN_OUT &&
        !this._messageHasProperty(message, deviceMessageProperties.MESSAGE_ID);
      if (
        scanQrInvalid ||
        scanQrResponseInvalid ||
        setEnvironmentInvalid ||
        getWebVersionInvalid ||
        userSignOutInvalid ||
        setWebVersionInvalid
      ) {
        const error = new Error('Structure of message is invalid');
        console.log(error);
        this.notificationService.showError('Connection error. Some features may be affected');
        return error;
      } else {
        return message;
      }
    }
    const error = new Error('Structure of message is invalid');
    console.log(error);
    return error;
  }

  private _hasValidMessageId(message: object): boolean {
    const message_id = message['message_id'];
    const enumValues = Object.values(deviceMessageId);
    return enumValues.includes(message_id);
  }

  private _messageHasProperty(message: Object, property: string) {
    return Object.prototype.hasOwnProperty.call(message, property);
  }
}
